import eventEnable from '../core/eventEnable';
export default function Bindings(name, binding){
	eventEnable(this);
	var self = this;
	var disposed = false;
	var list = [];
	this.add = add;
	this.getList = function(){
		return list;
	};
	this.dispose = dispose;
	this.remove = removeBinding;
	if(binding)
		self.add(binding);
	function dispose(){
		if(disposed)return;
		disposed = true;
		list.slice().forEach((binding)=>{/* because as we dispose them they will be calling back to remove themselves*/
			binding.dispose();
		});
		dispatchDispose(); //Not really needed because upon disposing the last binding the event will be dispatched.
	}
	function add(binding){
		listenForDispose(binding);
		list.push(binding);
	}
	function listenForDispose(binding){
		binding.addEventListener('dispose', callbackDispose);
	}
	function callbackDispose(e){
		removeBinding(e.binding);
	}
	function removeBinding(binding){
		var index = list.indexOf(binding);
		if(index<0)return;
		list.splice(index, 1);
		if(list.length>0)return;
		dispose();
	}
	function dispatchDispose(){
		self.dispatchEvent({type:'dispose', bindings:self});
	}
}